<template>
  <div class="lc-stream-background">
    <div
      v-if="!stream"
      class="flex items-center justify-center text-white text-opacity-60 text-lg font-primary"
      style="height: 38vw"
    >
      <span>Loading...</span>
    </div>

    <div
      v-if="stream"
      class="grid grid-cols-1 md:overflow-hidden py-8"
      :class="{ 'md:grid-cols-5 lg:grid-cols-3 gap-8': !!program }"
    >
      <div
        class="md:col-span-3 lg:col-span-2 pl-4 pr-4"
        :class="{ 'md:pl-6 md:pr-0': !!program }"
      >
        <Player
          :stream="stream"
          :source="currentSource"
          @register="player = $event"
        />
        <Switcher
          v-if="allSources.length > 1"
          :sources="allSources"
          :current="currentSource"
          @click="(index) => (this.currentSourceIndex = index)"
        />
      </div>

      <div
        v-if="program"
        class="relative md:col-span-2 lg:col-span-1 pl-4 md:pl-0"
      >
        <div class="lc-stream-reveal-gradient"></div>
        <div
          class="flex flex-col md:absolute md:inset-0 overflow-y-auto md:pr-6 pr-4"
        >
          <CurrentlyOn :stream="stream" :currentTime="currentTime" />
          <Program
            :stream="stream"
            :currentTime="currentTime"
            @seek-to="seekTo"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as AbsintheSocket from '@absinthe/socket';
import { Socket } from 'phoenix';
import { loadScript } from '@common/dom/load-script';
import CurrentlyOn from './CurrentlyOn';
import Player from './Player';
import Program from './Program';
import Switcher from './Switcher';
import { SOCKET_ENDPOINT } from '../constants';
import { stream as streamQuery } from '../gql/queries';
import { streamDeepUpdate } from '../gql/subscriptions';
import sortBy from 'lodash/sortBy';

let phxSocket = new Socket(SOCKET_ENDPOINT);
let socket = AbsintheSocket.create(phxSocket);

export default {
  components: { CurrentlyOn, Player, Program, Switcher },

  props: {
    streamId: Number,
    program: { type: Boolean, required: false, default: true }
  },

  data() {
    return {
      stream: null,
      currentSourceIndex: 0,
      player: null
    };
  },

  computed: {
    allSources() {
      return sortBy(this.stream.sources, 'position');
    },

    currentSource() {
      return sortBy(this.stream.sources, 'position')[this.currentSourceIndex];
    },

    currentTime() {
      return this.player && this.player.state.currentTime;
    }
  },

  async mounted() {
    await loadScript('https://cdn.jwplayer.com/libraries/nd2DCV4I.js');

    this.fetchStream();
    this.subscribeToStream();
  },

  methods: {
    fetchStream() {
      let notifier = AbsintheSocket.send(socket, {
        operation: streamQuery,
        variables: { id: this.streamId }
      });

      AbsintheSocket.observe(socket, notifier, {
        onResult: ({ data: { stream } }) => {
          this.stream = stream;
          console.log(this.stream);
        }
      });
    },

    subscribeToStream() {
      let notifier = AbsintheSocket.send(socket, {
        operation: streamDeepUpdate,
        variables: { id: this.streamId }
      });

      AbsintheSocket.observe(socket, notifier, {
        onResult: ({ data: { streamDeepUpdate } }) => {
          this.stream = streamDeepUpdate;
        }
      });
    },

    seekTo(seconds) {
      if (!this.player) return;

      this.player.seekTo(seconds);
    }
  }
};
</script>

<style lang="scss">
@import '../styles/variables';

.lc-stream-reveal-gradient {
  position: absolute;
  bottom: -1rem;
  left: 0;
  right: 1rem;
  height: 3rem;
  background: linear-gradient(180deg, rgba(2, 25, 52, 0) 0%, $black 100%);
  z-index: 10;
  pointer-events: none;
}

.lc-stream-background {
  background: $black;
}
</style>
